module.exports = __webpack_public_path__ + "static/media/commission_2.812f62e6.svg";